/// <field name='lc' type='Object'>Labour charges object</field>
window.stock = cafm.stock = {
    partsSelector: '#viewStocks',
    editStockWinHeight: 600,
    get partListSelector() { return '#' + cafm.res.consts.ElementId_PartList },
    changedHandlerName: 'cafm.stock.onStockChanged',
    init: function () {
        /// <summary>Stock initialiser</summary>

        var pv = $(stock.partsSelector);
        stock.partsView = pv;
    },
    getAssigsSaveWarningMessage: function () {
        return cafm.hd.workOrder.IsDirty ? cafm.res.str.UnsavedWoChangesWillBeSavedWithAssigs : cafm.res.str.StockAssigsSavedImmediately;
    },
    dataRetrieved: function (d) {
        /// <summary>Handler for when labour charge list data has been retrieved</summary>
        /// <param name="d" type="Array">Array of labour charge data</param>

        stock.partList = $(stock.partListSelector);
    },
    dataBound: function () {
        var defStoreLookup = $("#defaultWOStoreroom", cafm.views.getMainForm());
        if (defStoreLookup) {
            defStoreLookup.bindViewModel(cafm.hd.workOrder.DefaultStoreroom);
        }
        cafm.stock.onLoad();
    },
    onLoad: function () {
        $('#viewStocks').showMessage({ Type: cafm.enums.MessageType.Info, Title: cafm.stock.getAssigsSaveWarningMessage() });
    },
    onAssignStockLoad: function () {
        let panel = $('#actionPanel') // Non-mobile
        let vm = panel.getViewModel();
        if (!vm) {
            panel = $('#actionFormPlc'); // Mobile
            vm = panel.getViewModel();
        }
        if (!vm) {
            panel = $('#actionFormPlc2'); // Mobile+Scan
            vm = panel.getViewModel();
        }
        // Set values that will be missing from the VM after scan, then rebind the VM
        vm.AllowOtherLocations = cafm.hd.workOrderContext.stockAllowOtherLocations;
        vm.IncludeOutOfStock = cafm.hd.workOrderContext.stockIncludeOutOfStock;
        vm.WorkOrderLocationID = cafm.hd.workOrder.LocationID;
        panel.bindViewModel(vm);

        panel.showMessage({ Type: cafm.enums.MessageType.Info, Title: cafm.stock.getAssigsSaveWarningMessage() });
    },
    onPartLookupPreFetch: function (c) {

        if (c.PartGroupCodeId.value) {

            c.PartGroupCodeId = c.PartGroupCodeId.value;
        }
    },
    onStockOrPartLookupPreFetch: function (criteria) {

        var parentViewModel = cafm.views.getActiveActionWindowViewModel();
        var locID = parentViewModel['StoreroomLocationID'];
        locID = cafm.util.guidHasValue(locID) ? locID : cafm.auth.companyId();

        if (locID) {
            criteria.set('LocationID', locID)
        } else if (criteria.hasOwnProperty('LocationID')) {
            delete criteria.LocationID;
        }
        criteria.set('CurrencyFilter', { CurrencyCode: cafm.hd.workOrder.CurrencyCode });
    },
    onStoreroomLookupPreFetch: function (criteria) {

        var parentViewModel = cafm.views.getActiveActionWindowViewModel();
        var locID = parentViewModel['WorkOrderLocationID'],
            allLocs = parentViewModel['AllowOtherLocations'];

        if (locID && !allLocs) {
            criteria.set('LocationID', locID)
        } else if (criteria.hasOwnProperty('LocationID')) {
            delete criteria.LocationID;
        }
        criteria.set('CurrencyFilter', { CurrencyCode: cafm.hd.workOrder.CurrencyCode });
    },
    onStoreroomSelected: function (opts) {

        if (opts.value && opts.items) {
            var item = isArray(opts.items) ? opts.items.find((i) => i.ID == opts.value) : opts.items.ID == opts.value ? opts.items : undefined;
            if (item) {
                var parentViewModel = cafm.views.getActiveActionWindowViewModel();
                parentViewModel.set('StoreroomLocationID', item.LocationID);
            }
        }
    },
    partLookupSelected: function (e) {

        var vp = stock.partsView;
        var id = cafm.util.stringToArray(e.val);
        var existingParts = stock.partList.getLv().dataSource.data();

        // convert to json array to avoid picking up other objects
        if (existingParts && existingParts.toJSON()) {

            existingParts = existingParts.toJSON();
        }

        // filter out existing parts
        cafm.util.removeWhere(id, function (theId) {

            return cafm.util.exists(existingParts, function (part) {

                return theId == part.PartDefinitionId;
            });
        });

        var pids = [];
        id.forEach(function (i) {
            if (i != cafm.guid.empty) {
                pids.push({
                    IDs: cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), i)
                });
            }
        });

        if (pids.length) {

            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/AddParts'),
                description: cafm.res.str.TextRemovePart, // TODO: Wrong?
                values: pids,
                elementId: 'viewParts',
                loaderSelector: '#viewParts',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {

                        cafm.handlers.exe(stock.changedHandlerName, r);
                        stock.refreshPartList();
                        $('#partLookup').clearLookup({ suppressEvents: true, timeout: 500 });
                        $('#viewParts').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessagePartAdded });
                    }
                }
            });
        }
    },
    partQuantityChange: function (e) {

        var q = e.sender.value();

        if (cafm.util.isNum(q)) {

            var item = e.sender.wrapper.parents('.cLvIt:first');
            var part = stock.partList.getLv().dataSource.getByUid(item.data('uid'));

            if (part.ID) {

                cafm.actions.execute({

                    url: cafm.url.api('WorkOrder/UpdatePartQuantity'),
                    elementId: 'viewParts',
                    loaderSelector: '#viewParts',
                    loaderText: cafm.res.str.MessageUpdatingPartQuantity,
                    values: {
                        IDs: cafm.util.createParentChildId(cafm.hd.workOrder.get('ID'), part.ID),
                        ActualQuantity: q,
                        EstimatedQuantity: q
                    },
                    statusCodeFuncs: {

                        200: function (r, s) {

                            cafm.handlers.exe(stock.changedHandlerName, r);
                            stock.refreshPartList();

                            if (r.StockShortfallMessage) {

                                stock.partsView.showMessage({

                                    Type: cafm.enums.MessageType.Warning,
                                    Title: r.StockShortfallMessage
                                });
                            }
                            else {

                                stock.partsView.showMessage({

                                    Type: cafm.enums.MessageType.Success,
                                    Title: cafm.res.str.MessageUpdatedPartQuantity
                                });
                            }
                        }
                    }
                });
            }
        }
    },
    beforeGetStockBalancesByStorePartStock: function (args) {
        var vm = cafm.views.getActionForm().getViewModel() ? cafm.views.getActionForm().getViewModel() : cafm.views.getActionForm2().getViewModel();//TODO:Why is this needed!
        args.values.StoreroomID = vm.StoreroomID;
        args.values.PartID = vm.PartID;
        args.values.StockID = vm.StockID;
        args.values.IncludeOutOfStock = vm.IncludeOutOfStock;
    },
    onMobileAvailableBalancesSelectionChanged: function (e) {
        var ulElem = e.sender.element;
        $("li", ulElem.closest('ul', ulElem)).removeClass('k-state-focused');
        ulElem.find('.cLvIt.k-state-selected').addClass('k-state-focused')
    },
    partsToolbar: {
        add: function () {
            var store = (cafm.hd.workOrderContext.lastStoreroom) ? (cafm.hd.workOrderContext.lastStoreroom) : (cafm.hd.workOrder && cafm.hd.workOrder.DefaultStoreroom);
            var crit = {
                StoreroomID: store && store.ID,
                StoreroomDescription: store && store.Description,
                StoreroomLocationID: store && store.LocationID,
                WorkOrderLocationID: cafm.hd.workOrder.LocationID
            };
            cafm.stock.partsToolbar.addFromCriteria(crit, false);
        },
        addFromCriteria: function (crit, isScan) {
            var a = "helpdesk/assignStock";
            var vm = null;
            if (isScan === true) {
                a = a + "/?storeroomId={0}&stockId={1}".format(crit.StoreroomID, crit.StockID);
            } else {
                vm = crit;
                vm = {
                    ...vm,
                    AllowOtherLocations: cafm.hd.workOrderContext.stockAllowOtherLocations,
                    IncludeOutOfStock: cafm.hd.workOrderContext.stockIncludeOutOfStock
                };
            }
            var tit = 'Add Stock';
            var handle = cafm.hd.performFormAction;
            handle({
                viewModel: vm,
                key: 'AssignStock',
                action: a,
                title: tit,
                onLoad: cafm.stock.onAssignStockLoad,
                winOptions: {
                    title: tit,
                    height: cafm.stock.editStockWinHeight
                }
            });
        },
        edit: function (e) {
            var editBtn = $(e.target);
            var editTarget = editBtn.data('editTarget');
            var lv = editBtn.getLvFromTb();
            var id = editTarget.data('id');
            var selectedItem = lv.element.getListViewDataItem(id, 'ID');
            if (!selectedItem) {
                $('#viewStocks').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoStockSelected });
                return;
            };
            var a = 'helpdesk/assignStock?isEdit=true';
            var tit = 'Edit Stock';
            var vm =
            {
                AllowOtherLocations: cafm.hd.workOrderContext.stockAllowOtherLocations,
                StoreroomID: selectedItem.StoreroomID,
                StoreroomDescription: selectedItem.StoreroomDescription,
                PartID: selectedItem.PartID,
                PartDescription: selectedItem.PartDescription,
                StockID: selectedItem.StockID,
                StockDescription: selectedItem.StockDescription,
                IncludeOutOfStock: true,
                ActualQuantity: selectedItem.ActualQuantity,
                EstimatedQuantity: selectedItem.EstimatedQuantity,
                isEdit: true
            };
            var handle = cafm.hd.performFormAction;
            handle({
                viewModel: vm,
                key: 'AssignStock',
                action: a,
                title: tit,
                onLoad: cafm.stock.onAssignStockLoad,
                winOptions: {
                    title: tit,
                    height: cafm.stock.editStockWinHeight
                }
            });
        },
        remove: function (e) {
            var sel = $(e.target).getListSelectedDataItems()[0];
            if (!sel) {
                $('#viewStocks').showMessage({ Type: cafm.enums.MessageType.Warning, Title: cafm.res.str.MessageNoStockSelected });
                return;
            }

            var crit = {
                ParentID: cafm.hd.workOrder.ID,
                Identifier: {
                    StoreroomID: sel.StoreroomID,
                    PartID: sel.PartID,
                    StockID: sel.StockID,

                },
                IsUnassignConfirmed: true
            }

            cafm.util.yesNoDialogue({
                message: cafm.res.str.MessageRemoveStock + '  (' + cafm.stock.getAssigsSaveWarningMessage() + '.)',
                yesHandler: function () {
                    cafm.stock.partsToolbar.removeStock(crit);
                }
            });
        },
        removeStock: function (crit) {
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/RemoveAssignedStock'),
                description: cafm.res.str.TextRemoveAssignedStock,
                values: crit,
                elementId: 'viewStocks',
                loaderSelector: '#viewStocks',
                preventValidate: true,
                statusCodeFuncs: {
                    200: function (r) {
                        cafm.handlers.exe(cafm.stock.changedHandlerName, r);
                        stock.refreshPartList();
                        $('#viewStocks').showMessage({ Type: cafm.enums.MessageType.Success, Title: cafm.res.str.MessageItemsDeleted });
                    }
                }
            });
        },
        scan: function (e) {
            if (cafm.hd.workOrder.DefaultStoreroom && cafm.util.guidHasValue(cafm.hd.workOrder.DefaultStoreroom.ID)) {
                cafm.scanner.open(e, {
                    parentId: cafm.hd.workOrder.ID,
                    parentType: cafm.enums.ModelKey.WorkOrder,
                    initiatorType: cafm.enums.ModelKey.StockBalance,
                    scanPurpose: cafm.enums.ScanPurpose.AddStockToWorkOrder,
                    initiatorContextId: cafm.hd.workOrder.DefaultStoreroom && cafm.hd.workOrder.DefaultStoreroom.ID
                });
            } else {
                //There is no Default Store so User must lookup
                cafm.stock.partsToolbar.addFromCriteria({}, false);
            }
        }
    },
    refreshPartList: function () {

        cafm.util.refreshList({
            listSelector: stock.partListSelector,
            key: cafm.res.consts.DataKey_HelpdeskStock
        });
    },
    enablePermissibleFeatures: function (p) {

        var vp = $('#viewStocks'),
            lh = $('.cLvHead', vp),
            sl = $(stock.partListSelector);

        //if (isMobile) {

        if (p.add || p.remove) {

            lh.show();
        }
        else {

            lh.hide();
        }
        //}
        if (p.add) {

            $('#partLookupContainer', vp).show();
            $('[data-key="Add"]', lh).show();
        }
        if (!p.remove) {

            sl.disableListItemRemoving();
        }

        if (!p.edit) {

            sl.find('.partQuantity').prop('disabled', 'true');
        }

        if (p.scan) {
            $('[data-key="Scan"]', lh).show();
        }
    },
    getWorkOrderStocks: function () {

        return cafm.hd.getWorkOrderChildList('Stocks');
    }
}